import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

const StickyContainer = ({ children }: PropsWithChildren) => {
    const isMultipleStickyStart = checkFeatureFlagGate(
        featureFlags.wacLiftedBannerSticky
    );

    if (!isMultipleStickyStart) {
        return children;
    }

    return (
        <div data-testid="banner-nav-combo" css={sticky}>
            {children}
        </div>
    );
};

const sticky = css({
    position: "sticky",
    insetBlockStart: 0,
    zIndex: "5"
});

export default StickyContainer;
